const experienceData = {
  roles: [
    {
      id: 'catalystiq',
      company: 'CatalystIQ',
      companyNote: '(acquired Fox Dealer)',
      title: 'Full-Stack Software Engineer',
      dates: 'Aug 2025 – Present',
      bullets: [
        'Led frontend performance initiatives focused on Core Web Vitals, render-path optimization, deferred asset loading, and caching-aware rendering patterns, contributing to a 45% reduction in page-load times and 30–40 point improvements in Lighthouse scores.',
        'Designed a config-driven WordPress platform architecture featuring custom admin field systems, modular frontend rendering, Redis-backed caching, and extensible child-theme support for multiple automotive manufacturers.',
        'Established scalable frontend platform standards for shared component rendering, conditional asset loading, and caching-aware delivery patterns across multi-brand automotive websites.',
      ],
    },
    {
      id: 'foxdealer',
      company: 'Fox Dealer',
      companyNote: 'Pasadena, California',
      title: 'Software Engineer III',
      subtitle: 'Junior Front End Developer, Aug 2021 – Jul 2022',
      dates: 'Jul 2022 – Aug 2025',
      bullets: [
        'Engineered a full-stack SEO dashboard using React, Node.js, Express, and MySQL that reduced content publishing workflows from 2 hours to under 10 minutes across 500+ live automotive websites.',
        'Delivered 5 EV reservation applications for GMC Canada using Next.js, processing 2,500+ reservations across 50+ dealerships and directly contributing to seven-figure revenue with zero post-launch critical defects.',
        'Owned production reliability across 400+ live websites, resolving 5,350+ frontend and backend production issues while consistently meeting SLA turnaround expectations in a high-volume environment.',
        'Mentored 7 engineers through pair programming and internal documentation, reducing new hire ramp-up time from 6 weeks to 3 weeks and improving consistency across shared codebases.',
      ],
    },
  ],
};

export default experienceData;
